import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Logo, Btn, Input } from '../../components/UI';
import api from '../../utils/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault(); setLoading(true);
    try { await api.post('/api/auth/forgot-password', { email }); setSent(true); } catch {}
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 16, padding: 48, width: '100%', maxWidth: 420, textAlign: 'center' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}><Logo size={40} /></div>
        {sent ? (
          <>
            <div style={{ fontSize: 48, marginBottom: 16 }}>📱</div>
            <h2 style={{ color: 'var(--green)', marginBottom: 8 }}>Request Sent!</h2>
            <p style={{ color: 'var(--text-muted)', fontSize: 14, marginBottom: 24 }}>Admin has been notified. Your new password will be sent to your registered WhatsApp number.</p>
            <Link to="/login"><Btn full>Back to Login</Btn></Link>
          </>
        ) : (
          <>
            <h1 style={{ fontSize: 22, fontFamily: 'Sora', fontWeight: 700, marginBottom: 8 }}>Forgot Password</h1>
            <p style={{ color: 'var(--text-muted)', fontSize: 14, marginBottom: 24 }}>Enter your email and admin will reset your password via WhatsApp</p>
            <div style={{ background: 'rgba(255,200,0,0.05)', border: '1px solid rgba(255,200,0,0.15)', borderRadius: 10, padding: 14, marginBottom: 24, fontSize: 13, color: '#ffd700', textAlign: 'left' }}>
              ⚠️ Password will be reset by admin and sent to your registered WhatsApp number.
            </div>
            <form onSubmit={handleSubmit} style={{ textAlign: 'left' }}>
              <Input label="Email Address" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your@email.com" required />
              <Btn type="submit" disabled={loading} full size="lg">{loading ? 'Sending...' : 'Request Password Reset'}</Btn>
            </form>
            <div style={{ marginTop: 16 }}><Link to="/login" style={{ fontSize: 13, color: 'var(--green)' }}>← Back to Login</Link></div>
          </>
        )}
      </div>
    </div>
  );
}